import "./App.css";
import { Routes, Route, Outlet } from "react-router-dom";
import SignIn from "./components/SignIn/SignIn";
import SignUp from "./components/SignUp/SignUp";
import Home from "./components/Home/Home";
import RequireAuth from "./RequireAuth";
import SignUpVerification from "./components/SignUp/SignUpVerification";
import HomeLayout from "./components/Home/HomeLayout";
import MatchResume from "./components/MatchResume/MatchResume";
import MatchJobProfile from "./components/MatchJobProfile/MatchJobProfile";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import ThankYou from "./components/ThankYou/ThankYou";
import { AccountProvider } from "./context/AccountContext";
import CreateJobProfile from "./components/CreateJobProfile/CreateJobProfile";
import ConfigureJdWeights from "./components/CreateJobProfile/ConfigureJdWeights";
import MatchJobProfileResult from "./components/MatchJobProfile/MatchJobProfileResult";
import BaseLayout from "./components/Layout/BaseLayout";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import BatchOperations from "./components/BatchOperations/BatchOperations";
import CreateResumePool from "./components/CreateResumePool/CreateResumePool";
import EditExistingJobProfile from "./components/CreateJobProfile/EditExistingJobProfile";
import GenAISearchHome from "./components/GenAISearch/GenAISearchHome";
import GenAIResultsGrid from "./components/GenAISearch/GenAIResultsGrid";
import GenAIJsonView from "./components/GenAISearch/GenAIJsonView";
import NLP2SQL from "./components/GenAISearch/NLP2SQL";
import SQLQuery from "./components/GenAISearch/SQLQuery";
import SkillsSelector from "./components/CreateJobProfile/SkillsSelector";
import DashboardHome from "./components/Dashboard/DashboardHome";
import PoolRanking from "./components/PoolRanking/PoolRanking";
import PoolRankingProgress from "./components/PoolRanking/PoolRankingProgress";
import SubmitPoolRankingRequest from "./components/PoolRanking/SubmitPoolRankingRequest";
import BatchOperationProgress from "./components/BatchOperations/BatchOperationProgress";
import SuccessAndRedirect from "./components/Common/Ranking/SuccessAndRedirect";

function App() {
  return (
    <AccountProvider>
      <Routes>
        <Route path="/" element={<BaseLayout />}>
          <Route index exact element={<SignIn />} />

          <Route path="sign-up" exact element={<Outlet />}>
            <Route index element={<SignUp />} />
            <Route path="verification" element={<SignUpVerification />} />
          </Route>

          {/*Password */}
          {/* <Route path="reset-pwd" exact element={<ResetPassword />} /> */}
          <Route path="forgot-pwd" exact element={<ForgotPassword />} />
        </Route>

        {/* protected routes*/}
        <Route element={<RequireAuth />}>
          <Route path="home" element={<HomeLayout />}>
            <Route index element={<Home />} />

            { /* Dashboard*/}
            <Route path="dashboard" element={<Outlet />}>
              <Route index element={<DashboardHome />} />
            </Route>

            {/* CreateJobProfile*/}
            <Route path="create-job-profile" element={<Outlet />}>
              <Route index element={<CreateJobProfile />} />
              <Route path="skills-selector" element={<SkillsSelector />} />
              <Route path="skills-selector/configure-jd" element={<ConfigureJdWeights />} />
              <Route path="edit-ext-jd/:run_id" element={<EditExistingJobProfile />} />
            </Route>

            {/*Batch Operations*/}
            <Route path="batch-ops" element={<Outlet />}>
              <Route index element={<BatchOperations />} />
              <Route
                path="progress/:author_email/:run_id"
                element={<BatchOperationProgress />}
              />
            </Route>

            {/*CreateResumePool*/}
            <Route
              path="create-resume-pool"
              element={<CreateResumePool />}
            ></Route>

            {/* MatchJobProfile*/}
            <Route path="match-job-profile" element={<Outlet />}>
              <Route index element={<MatchJobProfile />} />
              <Route path="result" element={<MatchJobProfileResult />} />
            </Route>

            <Route path="match-resume" element={<MatchResume />} />

            <Route path="gen-ai" element={<Outlet />} >
              <Route index element={<GenAISearchHome />} />
              <Route path="grid/:filename" element={<GenAIResultsGrid />} />
              <Route path="gen-ai-json/:filename" element={<GenAIJsonView />} />
              <Route path="nlp-to-sql" element={<NLP2SQL />} />
              <Route path="sql" element={<SQLQuery />} />
            </Route>

            {/*Pool Ranking, Match Pool to Multiple Jds*/}
            <Route path="pool-ranking" element={<Outlet />}>
              <Route index element={<SubmitPoolRankingRequest />} />
              <Route path="progress/:author_email/:run_id" element={<PoolRankingProgress />} />
              <Route path="pool-ranking-list" element={<PoolRanking />} />
            </Route>

            <Route path="thankyou" element={<ThankYou />} />
            <Route path="success" element={<SuccessAndRedirect />} />
          </Route>
        </Route>

        {/*catch all*/}
        <Route path="*" element={<ErrorPage />}></Route>
      </Routes>
    </AccountProvider>
  );
}

export default App;
